// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + (chunkId === 2341 ? "modals" : chunkId) + "." + {"2341":"0945e8ae","4577":"07a28331","9603":"063ebf17"}[chunkId] + ".chunk.css";
};